const getUserLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          reject(error);
        },
        { timeout: 3000, enableHighAccuracy: true },
      );
    } else {
      reject(new Error('Geolocation is not supported by this browser.'));
    }
  });
};

export default getUserLocation;
